module.exports = __webpack_public_path__ + "img/7aab4c1.svg";